import React from "react";
import { useEffect, useState } from "react";
import blogApi from "../../utils/api/blogApi";
import { useNavigate } from "react-router-dom";
import { BlogResponseDto, LocalizationEnum } from "../../utils/types/blog";

const Blog = () => {
  const [blogs, setBlogs] = useState<BlogResponseDto[]>([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedLang, setSelectedLang] = useState<LocalizationEnum>(LocalizationEnum.MK);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    const loadBlogs = async () => {
      try {
        const { data } = await blogApi.get(`/blogs?page=${page}&pageSize=3&lang=${selectedLang}`);

        setBlogs(data.items);
        setTotalPages(data.totalPages);
      } catch (err) {
        console.error(err);
      }
      finally{
        setLoading(false)
      }
    };
    loadBlogs();
  }, [page, selectedLang]);

//   const handleLanguageChange = (lang: LocalizationEnum) => {
//     setSelectedLang(lang);
//     setPage(1); 
//   };

  const goToBlog = (id: number) => {
    navigate(`/blog/${id}`);
  };

  const stripHtml = (html:any) => {
    if (!html) return "";

    // Create a temporary DOM element
    const temp = document.createElement("div");
    temp.innerHTML = html;

    // Remove all script and style tags
    const scripts = temp.querySelectorAll("script, style");
    scripts.forEach((tag) => tag.remove());

    // Extract text content
    let text = temp.textContent || temp.innerText || "";

    // Clean extra whitespace
    return text.replace(/\s+/g, " ").trim();
  }

  if(loading)
    return (
       <div className="p-6 flex justify-center">
          <h1>Loading blogs...</h1>
       </div>
    )
 
 return (
 <div className="bg-white">
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold leading-tight mb-6">
            <span className="text-[#0c0407]">Блог за корисниците на Merakzy</span>
          </h1>
          <p className="text-lg md:text-xl text-[#0c0407] mx-auto mt-4">
            Следете ги новите можности и подобрувања на софтверот. Споделуваме информации за <br/> сите функционалности што ви помагаат да работите побрзо и поорганизирано.             
          </p>
        </div>
      </section>

      {/* BlogSection */}
       <section className="bg-white pb-24 mt-20 px-4 md:px-6">
        <div className="container mx-auto 2xl:px-20 space-y-20">

          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center"
            >
              <div className="xl:h-full">
                {blog.mainImageUrl && (
                  <img
                    src={blog.mainImageUrl}
                    alt={blog.title}
                    className="w-full h-full object-cover rounded-3xl shadow"
                  />
                )}
              </div>

              <div>
                <h2 className="sm:text-2xl xl:text-3xl font-bold mb-4 text-[#0c0407]">
                  {blog.title}
                </h2>

                <p className="text-gray-700 text-lg mb-6 line-clamp-5 md:line-clamp-1 lg:line-clamp-4 xl:line-clamp-6">
                  {stripHtml(blog.content)}
                </p>

                <button
                  onClick={() => goToBlog(blog.id)}
                  className="bg-[#fa0053] text-white px-8 py-3 hover:opacity-90 transition"
                  style={ {borderRadius: "16px"}}
                >
                  Повеќе
                </button>
              </div>
            </div>
          ))}
          <div className="flex justify-center items-center gap-2 mt-10">
              {/* First page */}
              <button
                onClick={() => setPage(1)}
                disabled={page === 1}
                className="text-black px-2 py-1 disabled:opacity-50"
              >
                &lt;&lt;
              </button>

              {/* Previous page */}
              <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                className="text-black px-2 py-1 disabled:opacity-50"
              >
                &lt;
              </button>

              {/* Page numbers */}
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <button
                  key={p}
                  onClick={() => setPage(p)}
                  className={`px-3 py-1 font-semibold ${
                    p === page
                      ? "bg-[#FA0053] text-white rounded-full w-10 h-10 flex items-center justify-center"
                      : "text-black"
                  }`}
                >
                  {p}
                </button>
              ))}

              {/* Next page */}
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
                className="text-black px-2 py-1 disabled:opacity-50"
              >
                &gt;
              </button>

              {/* Last page */}
              <button
                onClick={() => setPage(totalPages)}
                disabled={page === totalPages}
                className="text-black px-2 py-1 disabled:opacity-50"
              >
                &gt;&gt;
              </button>
            </div>
        </div>
      </section>

      {/* <FormSection /> */}
    </div>
  );
};

export default Blog;